import { render, staticRenderFns } from "./stopUsing.vue?vue&type=template&id=cf96a9cc&scoped=true"
import script from "./stopUsing.vue?vue&type=script&lang=js"
export * from "./stopUsing.vue?vue&type=script&lang=js"
import style0 from "./stopUsing.vue?vue&type=style&index=0&id=cf96a9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf96a9cc",
  null
  
)

export default component.exports